import React from 'react'

import LocationFinder from '@f/components/LocationFinder'
import CTA from '@f/elements/CTA/CTA'

interface SetLocationModalProps {
  closeModal: () => void
}

export const SetLocationModal = ({ closeModal }: SetLocationModalProps) => {
  const handleFilterApply = () => {
    closeModal()
  }

  return (
    <div className='f-c-ba-whi f-radius-card-large f-p-a-020 SearchResultsFilters-set-location-modal'>
      <span className='[ f-d-bl f-t-body f-c-fo-pri f-m-b-010 ]'>
        In einem Umkreis von 50 km, PLZ/Ort:
      </span>
      <LocationFinder
        wtLocation='search_results_filter_location_finder'
        className='[ f-d-bl ]'
        inputClassName='[ f-c-bo-neu025 ] has-border'
      />
      <div className='[ f-p-t-020 f-t-body f-c-fo-pri f-m-b-020 ]'>
        Wir empfehlen Ihnen den Bauort für verbesserte Preisangaben einzutragen,
        da diese sich je nach Umgebung unterscheiden.
      </div>
      <div
        className={`[ f-d-flr f-p-t-020 ] SearchResultsFilters-container-bottom`}>
        <CTA
          type='block-primary'
          className='SearchResultsFilters-cta'
          onClick={handleFilterApply}
          wtData={{
            'CTA-click': {
              label: 'filter-close',
              location: 'filter-panel'
            }
          }}>
          Anwenden
        </CTA>
      </div>
    </div>
  )
}
